/**
 * Online foglalás (/booking) megjelenése: független a menedzsment UI-tól (xclean_ui).
 * Ha nincs külön mentve (xclean_booking_ui), a menedzsment dizájnt követi.
 */

const STORAGE_KEY = "xclean_booking_ui";

export function getBookingUiFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "studio" || raw === "classic") return raw;
    const admin = localStorage.getItem("xclean_ui") || "studio";
    return admin === "studio" ? "studio" : "classic";
  } catch {
    return "studio";
  }
}

/** Csak a html data attribútum — induláskor, admin UI változáskor (öröklés) */
export function syncBookingUiAttribute() {
  const v = getBookingUiFromStorage();
  document.documentElement.setAttribute("data-booking-ui", v);
}

/** Beállításokban választás: ment + DOM + esemény */
export function applyBookingUi(ui) {
  const v = ui === "studio" ? "studio" : "classic";
  try {
    localStorage.setItem(STORAGE_KEY, v);
  } catch {
    /* ignore */
  }
  document.documentElement.setAttribute("data-booking-ui", v);
  window.dispatchEvent(new CustomEvent("xclean:booking-ui-changed", { detail: v }));
}
